import _ from 'underscore';
import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { Location24Regular } from '@fluentui/react-icons';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useFormService, FORM_STATES } from '@bingads-webui-fluent-component/form';
import { ValidatedCollapseCard, FormCardBasicHeader } from '@bingads-webui-campaign-react/validated-form-cards';
import { FormCardBody } from '@bingads-webui-fluent-component/form-cards';
import { ERROR_ENTITY } from '@bingads-webui-campaign-react/linkedin-data';
import { entityIs } from '@bingads-webui-campaign-react/form-error';
import { withControlErrorHandling, withUnvalidatedControlErrors } from '@bingads-webui-campaign-react/error-handling';

import { isLocationDataValid, TargetingLocations } from '../components/targeting-locations';
import { LocationsSkeleton } from '../components/skeletons';
import { withValidationWrapper } from '../utils';

const withUnvalidatedControlErrorsWrapper = _.partial(withUnvalidatedControlErrors, _, { filter: entityIs(ERROR_ENTITY.LocationTargeting) });

const ServerValidatedTargetingLocations = _.compose(
  withControlErrorHandling,
  withUnvalidatedControlErrorsWrapper,
  withValidationWrapper
)(TargetingLocations);

export const CollapsibleLocations = ({ defaultLocation, isLoading, ...cardProps }) => {
  const i18n = useContext(I18nContext);

  const { state } = useFormService();
  const isSavingFailed = state.matches(FORM_STATES.SAVING_FAILED);

  const validator = useCallback(newData => ((isSavingFailed && !isLocationDataValid(newData))
    ? [i18n.getString(_TL_('There are no location targets defined.'))]
    : []
  ), [i18n, isSavingFailed]);

  return (
    <ValidatedCollapseCard {...cardProps}>
      <FormCardBasicHeader
        title={i18n.getString(_TL_('Location'))}
        helpTopic="pop_BA_LinkedIn_Location"
        helpLabel={i18n.getString(_TL_('Click to learn more about location'))}
        contentBefore={<Location24Regular />}
      />
      <FormCardBody>
        {!isLoading ? (
          <ServerValidatedTargetingLocations
            defaultLocation={defaultLocation}
            validationProps={{ field: 'locations', validator }}
          />
        ) : <LocationsSkeleton />}
      </FormCardBody>
    </ValidatedCollapseCard>
  );
};

CollapsibleLocations.propTypes = {
  defaultLocation: PropTypes.shape({}).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

